export default __webpack_public_path__ + "static/media/Images.86d383f7.svg";